import { string } from 'yup';
import { BasePhoneEmailValidation } from './base-phone-email';

const IntraFormValidation = BasePhoneEmailValidation.shape({
  name: string().required('validations.name.required'),
  message: string().required('validations.message.required'),
});

export default IntraFormValidation;
